import React, {useContext, useEffect, useState} from 'react';
import {createSurvey, getAllPatients} from "../../../utils/api-lists/patient.api";
import {UserContext} from "../../../context/UserContext";

const CSVToJSONConverter = () => {
  const [jsonData, setJsonData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fileName, setFileName] = useState('');
  const [patients, setPatients] = useState([]);
  const {user} = useContext(UserContext);

  // Form fields definition from your provided structure
  const formFields = [
    {
      name: "age",
      label: "age",
      type: "number",
      required: true,
    },
    {
      name: "sex",
      label: "sex",
      type: "select",
      required: true,
      options: [
        {value: "male", label: "male"},
        {value: "female", label: "female"},
      ],
    },
    {
      name: "city",
      label: "city",
      type: "text",
      required: true,
    },
    {
      name: "skincareConcerns",
      label: "skincare_concerns",
      type: "creatable-multi-select",
      required: true,
      options: [
        {value: "all", label: "all"},
        {value: "dryness", label: "dryness"},
        {value: "acne", label: "acne"},
        {value: "sensitivity", label: "sensitivity"},
        {value: "wrinkles", label: "wrinkles"},
        {value: "hyper-pigmentation", label: "hyper_pigmentation"},
        {value: "oiliness", label: "oiliness"},
        {value: "skin-peeling", label: "skin_peeling"},
      ],
    },
    {
      name: "acneFrequency",
      label: "acne_frequency",
      type: "select",
      required: true,
      options: [
        {value: "never", label: "never"},
        {value: "occasionally", label: "occasionally"},
        {value: "sometimes", label: "sometimes"},
        {value: "often", label: "often"},
        {value: "always", label: "always"},
      ],
    },
    {
      name: "waterIntake",
      label: "water_intake",
      type: "select",
      required: true,
      options: [
        {value: "less_than_1_liter", label: "less_than_1_liter"},
        {value: "1_to_2_liters", label: "1_to_2_liters"},
        {value: "2_to_3_liters", label: "2_to_3_liters"},
        {value: "more_than_3_liters", label: "more_than_3_liters"},
      ],
    },
    {
      name: "sleepOptions",
      label: "sleep_options",
      type: "select",
      required: true,
      options: [
        {value: "less_than_4_hours", label: "less_than_4_hours"},
        {value: "4_to_6_hours", label: "4_to_6_hours"},
        {value: "6_to_8_hours", label: "6_to_8_hours"},
        {value: "more_than_8_hours", label: "more_than_8_hours"},
      ],
    },
    {
      name: "stressLevel",
      label: "stress_level",
      type: "select",
      required: true,
      options: [
        {value: "low", label: "low"},
        {value: "moderate", label: "moderate"},
        {value: "high", label: "high"},
        {value: "very_high", label: "very_high"},
      ],
    },
    {
      name: "exerciseLevel",
      label: "exercise_level",
      type: "select",
      required: true,
      options: [
        {value: "never", label: "never"},
        {value: "1_2_times_a_week", label: "1_2_times_a_week"},
        {value: "3_4_times_a_week", label: "3_4_times_a_week"},
        {value: "more_than_4_times", label: "more_than_4_times"},
      ],
    },
    {
      name: "petOwernership",
      label: "pet_ownership",
      type: "creatable-multi-select",
      required: true,
      options: [
        {value: "no_pets", label: "no_pets"},
        {value: "cat", label: "cat"},
        {value: "dog", label: "dog"},
      ],
    },
    {
      name: "dietaryHabits",
      label: "dietary_habits",
      type: "multi-select",
      required: true,
      options: [
        {value: "dairy", label: "dairy"},
        {value: "alcohol", label: "alcohol"},
        {value: "processed_meat", label: "processed_meat"},
        {value: "veggies_and_fruits", label: "veggies_and_fruits"},
        {value: "dietary_supplements", label: "dietary_supplements"},
        {value: "refined_sugar", label: "refined_sugarr"},
        {
          value: "caffeine",
          label: "caffeine",
        },
      ],
    },
    {
      name: "smokeHabit",
      label: "smoke_habit",
      type: "select",
      required: true,
      options: [
        {value: "yes", label: "yes"},
        {value: "no", label: "no"},
      ],
    },
    {
      name: "screenTime",
      label: "screen_time",
      type: "select",
      required: true,
      options: [
        {value: "0_3_hours", label: "0_3_hours"},
        {value: "3_6_hours", label: "3_6_hours"},
        {value: "6_9_hours", label: "6_9_hours"},
        {value: "more_than_9_hours", label: "more_than_9_hours"},
      ],
    },
    {
      name: "sunligtExposure",
      label: "sunlight_exposure",
      type: "select",
      required: true,
      options: [
        {value: "less_than_1_hour", label: "less_than_1_hour"},
        {value: "1_to_3_hours", label: "1_to_3_hours"},
        {value: "3_to_6_hours", label: "3_to_6_hours"},
        {value: "more_than_6_hours", label: "more_than_6_hours"},
      ],
    },
    {
      name: "sunScreenUsage",
      label: "sun_screen_usage",
      type: "select",
      required: true,
      options: [
        {value: "never", label: "never"},
        {value: "beach_days", label: "beach_days"},
        {value: "summer_only", label: "summer_only"},
        {value: "sunny_days", label: "sunny_days"},
        {value: "always", label: "always"},
      ],
    },
    {
      name: "skincareProducts",
      label: "skincare_products",
      type: "creatable-multi-select",
      required: true,
      options: [
        {value: "cleanser", label: "cleanser"},
        {value: "moisturiser", label: "moisturiser"},
        {value: "serum", label: "serum"},
        {value: "toner", label: "toner"},
        {value: "eye_cream", label: "eye_cream"},
        {value: "spf", label: "spf"},
        {value: "acne_medication", label: "acne_medication"},
        {value: "retinol", label: "retinol"},
        {value: "nothing", label: "nothing"},
      ],
    },
    {
      name: "makeupFrequency",
      label: "makeup_frequency",
      type: "select",
      required: true,
      options: [
        {value: "never", label: "never"},
        {value: "less_than_3_times_a_week", label: "less_than_3_times_a_week"},
        {value: "3_to_5_times_a_week", label: "3_to_5_times_a_week"},
        {value: "every_day", label: "every_day"},
      ],
    },
  ];

  useEffect(() => {
    if (!user?.id) return;

    const fetchPatients = async () => {
      try {
        const data = await getAllPatients(user.id);
        setPatients(data);
      } catch (err) {

      }
    };

    fetchPatients();
  }, [user?.id]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFileName(file.name);
    setIsLoading(true);

    const reader = new FileReader();

    reader.onload = (e) => {
      const csvContent = e.target.result;
      const parsedData = parseCSV(csvContent);
      const mappedData = mapCSVToFormFields(parsedData);
      setJsonData(mappedData);
      console.log('Original CSV Data:', parsedData);
      console.log('Mapped Form Data:', mappedData);
      mapToPatientByMail(mappedData);
      setIsLoading(false);
    };

    reader.onerror = () => {
      console.error('Error reading file');
      setIsLoading(false);
    };

    reader.readAsText(file);
  };

  const mapToPatientByMail = async (data) => {
    patients.forEach((patient) => {
      const email = patient.email;
      const survey = data.find((survey) => survey.email === email);
      if (survey) {
        try {
          console.log(patient.email, survey);
          onSave(patient.id, survey);
        } catch (error) {
          console.log(error.message);
        }
      }
    })
  }


  const onSave = async (patientId, formData) => {
    try {
      await createSurvey(patientId, user.id, formData);
    } catch (error) {
      console.error("Error submitting survey:", error);
    }
  };


  // Parse CSV to initial JSON structure
  const parseCSV = (csvText) => {
    // Split by lines and filter out empty lines
    const lines = csvText.split('\n').filter(line => line.trim() !== '');

    if (lines.length === 0) return [];

    // Use semicolon as delimiter
    const headers = lines[0].split(';');

    // Convert each line to an object
    return lines.slice(1).map(line => {
      const values = line.split(';');
      const entry = {};

      headers.forEach((header, index) => {
        // Use empty string if value is undefined
        entry[header] = index < values.length ? values[index] : '';
      });

      return entry;
    });
  };

  // Map CSV data to form fields structure
  const mapCSVToFormFields = (csvData) => {
    return csvData.map(entry => {
      const mappedEntry = {};

      mappedEntry.email = entry["Email Address"];

      // Age
      mappedEntry.age = parseInt(entry["Whats your age"] || 0);

      // Sex
      mappedEntry.sex = entry["What's your biological sex?"]?.toLowerCase() === "male" ? "male" : "female";

      // City
      mappedEntry.city = entry["Which city do you live in?"] || "";

      // Skincare Concerns
      mappedEntry.skincareConcerns = entry["What concerns do you address in your skincare routine?"] || "";

      // Acne Frequency
      mappedEntry.acneFrequency = entry["How often do you experience acne breakouts?"] || "";

      // Water Intake
      const waterIntake = entry["How much water do you drink every day?"];
      mappedEntry.waterIntake = entry["How much water do you drink every day?"] || '';

      // Sleep Options
      const sleepHours = entry["How much sleep do you get on average per night?"];
      mappedEntry.sleepOptions = sleepHours || "";

      // Stress Level
      const stressLevel = entry["How would you describe your current stress level?"]?.toLowerCase() || "";
      mappedEntry.stressLevel = entry["How would you describe your current stress level?"] || "";

      // Exercise Level
      const exerciseFrequency = entry["How often do you exercise?"];
      mappedEntry.exerciseLevel = exerciseFrequency || "";
      // Pet Ownership
      const pets = entry["Do you have any pets?"];
      mappedEntry.petOwernership = entry["Do you have any pets?"] || "";

      // Dietary Habits
      const dietItems = entry["Which of these items do you consume almost every day?"];
      mappedEntry.dietaryHabits = entry["Which of these items do you consume almost every day?"] || "";

      // Smoke Habit
      mappedEntry.smokeHabit = entry["Do you smoke?"] || "";

      // Screen Time
      const screenTime = entry["What's your daily screen time (phone, computer, TV)?"];
      mappedEntry.screenTime = entry["What's your daily screen time (phone, computer, TV)?"] || "";
      // Sunlight Exposure
      const sunlightExposure = entry["How much direct sunlight are you exposed daily on average?"];
      mappedEntry.sunligtExposure = sunlightExposure || "";

      // Sunscreen Usage
      const sunscreenUsage = entry["How often do you use sunscreen?"];
      mappedEntry.sunScreenUsage = sunscreenUsage || "";

      // Skincare Products
      const products = entry["Which products are in your skincare routine?"];
      mappedEntry.skincareProducts = products || "";

      // Makeup Frequency
      const makeupFrequency = entry["How often do you wear make up?"];
      mappedEntry.makeupFrequency = makeupFrequency || "";

      return mappedEntry;
    });
  };

  // Helper mapping functions
  const mapWaterIntake = (waterIntake) => {
    if (!waterIntake) return "less_than_1_liter";
    if (waterIntake.includes("Less than 0.5L") || waterIntake.includes("0.5 - 1 L")) return "less_than_1_liter";
    if (waterIntake.includes("1 - 2 L")) return "1_to_2_liters";
    if (waterIntake.includes("Over 2 L")) return "more_than_3_liters";
    return "less_than_1_liter";
  };

  const mapSleepHours = (sleepHours) => {
    if (!sleepHours) return "6_to_8_hours";
    if (sleepHours.includes("Less than 4 hours")) return "less_than_4_hours";
    if (sleepHours.includes("5 to 6 hours")) return "4_to_6_hours";
    if (sleepHours.includes("7 to 8 hours")) return "6_to_8_hours";
    if (sleepHours.includes("More than 8 hours")) return "more_than_8_hours";
    return "6_to_8_hours";
  };

  const mapStressLevel = (stressLevel) => {
    if (!stressLevel) return "moderate";
    if (stressLevel.includes("mild")) return "low";
    if (stressLevel.includes("moderate")) return "moderate";
    if (stressLevel.includes("high")) return "high";
    return "moderate";
  };

  const mapExerciseLevel = (exerciseFrequency) => {
    if (!exerciseFrequency) return "never";
    if (exerciseFrequency.includes("Never")) return "never";
    if (exerciseFrequency.includes("1-2 times")) return "1_2_times_a_week";
    if (exerciseFrequency.includes("3-4 times")) return "3_4_times_a_week";
    if (exerciseFrequency.includes("more than 4")) return "more_than_4_times";
    return "never";
  };

  const mapPetOwnership = (pets) => {
    if (!pets) return [{value: "no_pets", label: "no_pets"}];
    if (pets.toLowerCase().includes("no")) return [{value: "no_pets", label: "no_pets"}];

    const petArr = [];
    if (pets.toLowerCase().includes("dog")) petArr.push({value: "dog", label: "dog"});
    if (pets.toLowerCase().includes("cat")) petArr.push({value: "cat", label: "cat"});

    return petArr.length ? petArr : [{value: "no_pets", label: "no_pets"}];
  };

  const mapDietaryHabits = (dietItems) => {
    if (!dietItems) return [];
    const items = dietItems.split(', ');
    const mappedItems = [];

    if (items.includes("Dairy")) mappedItems.push({value: "dairy", label: "dairy"});
    if (items.includes("Alcohol")) mappedItems.push({value: "alcohol", label: "alcohol"});
    if (items.includes("Processed Meat")) mappedItems.push({value: "processed_meat", label: "processed_meat"});
    if (items.includes("Veggies and Fruits")) mappedItems.push({
      value: "veggies_and_fruits",
      label: "veggies_and_fruits"
    });
    if (items.includes("Dietary Supplements")) mappedItems.push({
      value: "dietary_supplements",
      label: "dietary_supplements"
    });
    if (items.includes("Refined sugar")) mappedItems.push({value: "refined_sugar", label: "refined_sugarr"});
    if (items.includes("Caffeine") || items.includes("Coffee")) mappedItems.push({
      value: "caffeine",
      label: "caffeine"
    });

    return mappedItems;
  };

  const mapScreenTime = (screenTime) => {
    if (!screenTime) return "3_6_hours";
    if (screenTime.includes("03-Jun")) return "3_6_hours";
    if (screenTime.includes("06-Sep")) return "6_9_hours";
    if (screenTime.includes("more than 9")) return "more_than_9_hours";
    return "3_6_hours";
  };

  const mapSunlightExposure = (sunlightExposure) => {
    if (!sunlightExposure) return "less_than_1_hour";
    if (sunlightExposure.includes("less than 1 hour")) return "less_than_1_hour";
    if (sunlightExposure.includes("1 to 3")) return "1_to_3_hours";
    if (sunlightExposure.includes("3 to 6")) return "3_to_6_hours";
    if (sunlightExposure.includes("more than 6")) return "more_than_6_hours";
    return "less_than_1_hour";
  };

  const mapSunscreenUsage = (sunscreenUsage) => {
    if (!sunscreenUsage) return "never";
    if (sunscreenUsage.includes("Never")) return "never";
    if (sunscreenUsage.includes("beach")) return "beach_days";
    if (sunscreenUsage.includes("sunny")) return "sunny_days";
    if (sunscreenUsage.includes("Always")) return "always";
    return "never";
  };

  const mapSkincareProducts = (products) => {
    if (!products) return [];
    if (products.toLowerCase().includes("nothing")) return [{value: "nothing", label: "nothing"}];

    const items = products.split(', ');
    const mappedItems = [];

    if (items.includes("Cleanser")) mappedItems.push({value: "cleanser", label: "cleanser"});
    if (items.includes("Moisturiser")) mappedItems.push({value: "moisturiser", label: "moisturiser"});
    if (items.includes("Serum")) mappedItems.push({value: "serum", label: "serum"});
    if (items.includes("Toner")) mappedItems.push({value: "toner", label: "toner"});
    if (items.includes("Eye cream")) mappedItems.push({value: "eye_cream", label: "eye_cream"});
    if (items.includes("SPF")) mappedItems.push({value: "spf", label: "spf"});
    if (items.includes("Acne medication")) mappedItems.push({value: "acne_medication", label: "acne_medication"});
    if (items.includes("Retinol based products")) mappedItems.push({value: "retinol", label: "retinol"});

    return mappedItems;
  };

  const mapMakeupFrequency = (makeupFrequency) => {
    if (!makeupFrequency) return "never";
    if (makeupFrequency.includes("Never")) return "never";
    if (makeupFrequency.includes("less than 3")) return "less_than_3_times_a_week";
    if (makeupFrequency.includes("3 to 5")) return "3_to_5_times_a_week";
    if (makeupFrequency.includes("Every day")) return "every_day";
    return "never";
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">CSV to Form Data Converter</h1>

      <div className="mb-6">
        <label className="block text-gray-700 mb-2">Upload CSV File:</label>
        <input
          type="file"
          accept=".csv"
          onChange={handleFileUpload}
          className="block w-full text-gray-700 border border-gray-300 rounded py-2 px-3 mb-2"
        />
        <p className="text-sm text-gray-500">
          Uploads CSV and maps to form field format
        </p>
      </div>

      {isLoading && (
        <div className="mb-4">
          <p>Processing file...</p>
        </div>
      )}

      {fileName && !isLoading && (
        <div className="mb-4">
          <p className="font-medium">File: {fileName}</p>
          <p className="text-green-600">
            ✓ Conversion complete! Check browser console for JSON output.
          </p>
          <div className="mt-2 flex space-x-2">
            <button
              onClick={() => console.log('Original Data:', jsonData)}
              className="bg-blue-600 text-white py-1 px-3 rounded hover:bg-blue-700"
            >
              Log Mapped JSON to Console
            </button>
          </div>
        </div>
      )}

      <div className="mt-8 p-4 bg-gray-100 rounded">
        <h2 className="font-bold mb-2">How to use:</h2>
        <ol className="list-decimal list-inside space-y-1">
          <li>Click "Choose File" and select your CSV file</li>
          <li>The file will be converted to JSON and mapped to match your form fields format</li>
          <li>The resulting JSON will be logged to your browser's console</li>
          <li>Open your browser's developer tools to view the data (F12 or right-click → Inspect → Console)</li>
        </ol>
      </div>
    </div>
  );
};

export default CSVToJSONConverter;
